/**
 * API - BMOS
 * https://bitbucket.org/interlective/bridgealliance_react_frontend
 */


async function searchBMOs(token,page,formdata) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-bmos?page=${page}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(formdata)
    });
  }
  async function getBMO(token,id) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/get-bmo?bmoid=${id}`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      }
    });
  }

  async function sendEmailToBMO(token,formdata) {
    return fetch(`${process.env.REACT_APP_API_BASE_URL}/wp-json/wpba/frontend/ask-more-bmo`, {
      timeout: process.env.REACT_APP_DEFAULT_TIMEOUT,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(formdata)
    });
  }

export default {
    searchBMOs,getBMO,sendEmailToBMO
}